import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss';
import StepOne from './steps/StepOne';
import StepTwo from './steps/StepTwo';
import StepThree from './steps/StepThree';
import StepFour from './steps/StepFour';
import StepFive from './steps/StepFive';
import StepSix from './steps/StepSix';

const StepBar = ({ history }) => {
        let productPrice = useSelector(state => state.productPrice);
        let visitedStep = useSelector(state => state.visitedStep);
        let isShop = useSelector(state => state.isShop);
        const dispatch  = useDispatch()
        let navigate = useNavigate();

        let howManySteps = [ 
            {
                number: 1,
                text: 'Calculation'
            },
            {
                number: 2,
                text: 'Company Details'
            },
            {
                number: 3,
                text: 'Authorized Signatory Info'
            },
            {
                number: 4,
                text: 'Financial Information'
            },
            {
                number: 5,
                text: 'Summary'
            },
        ];

        
        let step                    = useSelector(state => state.steps);
        let [ load, setLoad ]       = useState( false );
        
        // protect changes page with link
        // useEffect(() => {
        //     if (!load) {
        //         console.log(isShop)
        //         if ( typeof(productPriceEnd) == 'object' && !isShop) {
        //             history.push('/')
        //         };
        //         setLoad(true)
        //     }
        // }, [load])

        // useEffect(() => {
        //         let copyVisited = visitedStep;
        //         if ( copyVisited.indexOf(step) < 0 ) {
        //             copyVisited.push(step);
        //         }
        //         dispatch({ type: 'VISITED_STEP_CHANGE', value: copyVisited })
            
        // }, [step])

        useEffect(() => {
            let copyVisited = [...visitedStep];

            // Usuń wszystkie kroki większe niż bieżący krok
            copyVisited = copyVisited.filter(s => s <= step);

            // Dodaj krok, jeśli go nie ma
            if (copyVisited.indexOf(step) < 0) {
                copyVisited.push(step);
            }

            dispatch({ type: 'VISITED_STEP_CHANGE', value: copyVisited });

        }, [step]);

        let changeStep = (clickedIndex) => {
            if(clickedIndex == 1) {
                navigate( isShop ? "/shop" : "/");
            }else{
                if ( visitedStep.indexOf(clickedIndex) >= 0 ) {
                    navigate('/step/'+ clickedIndex);
                }
            }
        }
        
        const Steps = function(props) {
            let items = props.steps;
            let array = items.map((item, index) =>  
                <div key={ item.number } className={ "step " + ( props.step == item.number ? 'active': '')  + ( props.step > item.number ? 'active-prev': '')}>
                    <div className="overflow-wrap" onClick={() => changeStep( index + 1)}>
                        <span className={ visitedStep.indexOf(index + 1) < 0 ? 'bigger': '' }>
                            { index + 1 === 1 && 
                                <>
                                    <StepOne active={ step }  setFunction={ () => changeStep( index + 1)} />
                                    <div className="offert-wrap">
                                        <div className={"offert" + ( step === 1 ? ' active' : '')}>
                                            <p>Oferta</p>
                                        </div>
                                    </div>
                                    
                                </>
                            }
                            { index + 1 === 2 && 
                                <>
                                    <StepTwo active={ step } setFunction={ () => changeStep( index + 1)}/>
                                    <div className="offert-wrap right">
                                        <div className={"offert" + ( step > 1 ? ' active' : '') }>
                                            <p>Wniosek</p>
                                        </div>
                                    </div>
                                </>
                            }
                            { index + 1 === 3 && 
                                <StepThree active={ step } setFunction={ () => changeStep( index + 1)}/>
                            }
                            { index + 1 === 4 && 
                                <StepFour active={ step } setFunction={ () => changeStep( index + 1)}/>
                            }
                            { index + 1 === 5 && 
                                <StepFive active={ step } setFunction={ () => changeStep( index + 1)}/>
                            }
                            { index + 1 === 6 && 
                                <StepSix active={ step } setFunction={ () => changeStep( index + 1)}/>
                            }
                            <p>{ item.text }</p>
                        </span>
                    </div>
                </div>
            );
            return (
                <div className="steps-wrap">
                    <div className="steps-container">
                        { array }
                    </div>
                    <div className="offert-switch">
                        
                        
                    </div>
                </div>
            );
        }

        return (
            <>  
                {/* { step >=  1 && step <= 5
                     && <Steps step={ step } steps={ howManySteps } /> } */}
                     <Steps step={ step } steps={ howManySteps } />
            </>
        )
}

export default StepBar;